<div class="modal-header">
  <h3 class="modal-title">Share Library</h3>
  <button class="fa fa-times" [mat-dialog-close]="" style="float: right;cursor: pointer;background: none;border:none"
    aria-hidden="true"></button>
</div>
<div class="modal-body modal-body-height">
  <app-progress-bar [isLoading]="isShareLoading"></app-progress-bar>
  <div class="row">
    <div [ngClass]="isShareGlobally ? 'col-lg-5' : 'col-lg-6'">
      <label class="control-label fw">Regulation Library</label>
      <mat-chip-grid #rlList>
        <mat-chip-row *ngFor="let reg of regLibraryDD" [selectable]="selectable" [removable]="removable"
          (removed)="removeRL(reg)">
          {{reg}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row> 
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #rlInput
          (keydown)="getFilteredData('RegulationLibrary', $event)" [formControl]="searchRLCntrl"
          [matAutocomplete]="rlAutocomplete" [matChipInputFor]="rlList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addRL($event)">
      </mat-chip-grid>
      <mat-autocomplete #rlAutocomplete="matAutocomplete" (optionSelected)="selectedRLEvent($event)">
        <mat-option *ngFor="let reg of searchedLibrary" [value]="reg.value">
          <span [attr.class]="getIconClass(reg.name)"></span>
          {{reg.name}}
        </mat-option>
      </mat-autocomplete>
      <div class="mb-2 fg-g-red">
        <small *ngIf="!isRLAllow">Please select at least one library</small>
      </div>
    </div>
    <div [ngClass]="isShareGlobally ? 'col-lg-5' : 'col-lg-6'">
      <label class="control-label fw">User</label>
      <mat-chip-grid #userList>
        <mat-chip-row *ngFor="let usr of userDD" [selectable]="selectable" [removable]="removable"
          (removed)="removeUser(usr)">
          {{usr}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row> 
        <input class="form-control form-control-sm mat-autodd-input border-bottom" #usrInput
          (keydown)="getFilteredData('User', $event)" [formControl]="searchUserCntrl"
          [matAutocomplete]="usrAutocomplete" [matChipInputFor]="userList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addUser($event)">
      </mat-chip-grid>
      <mat-autocomplete #usrAutocomplete="matAutocomplete" (optionSelected)="selectedUserEvent($event)">
        <mat-option *ngFor="let user of searchedUser" [value]="user.value">
          {{user.name}}
        </mat-option>
      </mat-autocomplete>
      <div class="mb-2 fg-g-red">
        <small *ngIf="!isUAllow">Please select at least one user</small>
      </div>
    </div>
    <!-- <div class="col-lg-2" *ngIf="isShareGlobally"></div> -->
    <div class="col-lg-2">
      <div class="form-group">
        <div class="left inline control-label mt-4 fw f-16">
          <i class="fa fa-square-o icon-font" (click)="isGlobal = true" *ngIf="!isGlobal"
            aria-hidden="true"></i>
          <i class="fa fa-check-square icon-font" (click)="isGlobal = false" *ngIf="isGlobal"
            aria-hidden="true"></i>
          Is Global
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn bg-g-lightGreen btn-sm" (click)="shareRegulationLibrary()">Save</button>
</div>
